<template>
    <div class="pb-[40px]">
        <button
            class="mb-[16px] flex w-full cursor-pointer items-center justify-between text-left text-[18px] font-medium focus-outline-only"
            @click="isExpanded = !isExpanded"
        >
            <div class="w-[85%]">
                {{ item.title }}
            </div>

            <div class="flex w-[15%] items-center justify-end">
                <arrow-drop-down-icon class="arrow-drop-down-icon" :class="{ 'rotate': !isExpanded }" />
            </div>
        </button>
        <collapse :when="isExpanded" >
            <div class="list-disc space-y-[16px] px-[24px] text-[16px] leading-[24px]">
                <div class="help-content" v-html="item.content" />
            </div>
        </collapse>
    </div>
</template>

<script>
    import { Collapse } from 'vue-collapsed';
    import ArrowDropDownIcon from '../../icons/ArrowDropDownIcon.vue';

    export default {
        components: {
            ArrowDropDownIcon,
            Collapse,
        },

        data() {
            return {
                isExpanded: this.items?.length === 1,
            };
        },

        props: {
            item: {
                type: Object,
                required: true,
            },

            items: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .arrow-drop-down-icon {
        transition: transform 0.3s ease;
    }

    .arrow-drop-down-icon.rotate {
        transform: rotate(-180deg);
    }

    .help-content :deep(li) {
        list-style: disc;

        margin-bottom: 1rem;
    }

    .help-content :deep(a) {
        color: #4169e1;

        text-decoration: underline;
        text-underline-offset: 2px;
    }
</style>
